import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
export const IconWrapper = ({ className = '', children, size = 16, render = 'included', t = 'auto', r = 'auto', b = 'auto', l = 'auto', ...marginProps }) => (React.createElement(Container, { className: className, ...marginProps },
    children,
    React.createElement(IconContainer, { "$size": size, "$t": t, "$r": r, "$b": b, "$l": l },
        render === 'included' && (React.createElement(Icon, { render: "included", size: size, color: "apple" })),
        render === 'excluded' && (React.createElement(Icon, { render: "excluded", size: size, color: "strawberry" })))));
const Container = styled(Box) `
  position: relative;
  width: fit-content;
`;
const IconContainer = styled.div(({ $size, $t, $r, $b, $l }) => css `
    position: absolute;
    width: 100%;
    max-width: ${$size}px;
    height: ${$size}px;
    top: ${$t};
    right: ${$r};
    bottom: ${$b};
    left: ${$l};
  `);
//# sourceMappingURL=IconWrapper.js.map